import { useEffect } from "react";
import useStepFlow from "src/Modules/Hotels/hooks/useStepsFlow";
import WizardBody from "./Components/WizardBody";
import WizardHeader from "./Components/WizardHeader";

export default function Wizard() {
  const { ensureStepAllowed } = useStepFlow();

  useEffect(() => {
    ensureStepAllowed();
  }, []);

  return (
    <div className="border-border-default flex w-full flex-col items-start rounded-none gap-4">
      <WizardHeader />
      <WizardBody />
    </div>
  );
}
